import { lazyImport } from '../../Utils/Loading/loadingHelpers'

export const DoughnutChartLazy = lazyImport(() => import('./DoughnutChart'))